import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getMerchandiseItemViews from 'checkout/selectors/view/itemViews/getMerchandiseItemViews'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutMerchandisePointsCalculationRequests = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (merchandiseViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!merchandiseViews.hasRequiredData) return EmptyArray

    return merchandiseViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      loyaltyProductType: itemView.loyalty.productType!,
      itemId: itemView.item.itemId,
      promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
    }))
  },
)

export default getCheckoutMerchandisePointsCalculationRequests
